import { render, staticRenderFns } from "./SenderNoticeSave.vue?vue&type=template&id=5da47e30&scoped=true&"
import script from "./SenderNoticeSave.vue?vue&type=script&lang=js&"
export * from "./SenderNoticeSave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da47e30",
  null
  
)

export default component.exports